export const dataChangesSchema = {
	title: 'data changes schema',
	version: 4,
	primaryKey: 'changeId',
	type: 'object',
	properties: {
		changeId: {
			type: 'string',
			maxLength: 70,
		},
		isSynced: {
			type: 'boolean',
		},
		checkDone: {
			type: 'boolean',
		},
		vehicleData: {
			type: 'string',
		},
		insertTime: {
			type: 'number',
		},
		scheduledLegId: {
			type: 'string',
		},
		bookingId: {
			type: 'string',
		},
		type: {
			type: 'string',
			// "START" or "DONE" leg | "EXECUTING" or "DONE" or "CANCELED_NO_SHOW" booking
		},
		attempts: {
			type: 'number',
		},
		ref: {
			type: 'string',
		},
		checkedInLegs: {
			type: 'array',
			items: { type: 'string' },
		},
		options: {
			type: ['object', 'null'],
		},
	},
	required: ['changeId', 'type', 'insertTime'],
};
